import {
  LitElement,
  html,
  customElement,
  state,
} from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { bound } from '@oskecare/fe-utilities/lib/decorators';
import '@oskecare/ui-library/components/modal';
import { config } from '../config.js';

@customElement('osk-maintenance-message')
class MaintenanceMessage extends LitElement {
  /**
   * @type {boolean}
   */
  @state()
  accessor _wasSeen = false;

  @bound
  handleCloseModal() {
    this._wasSeen = true;
  }

  /**
   * Disables shadowRoot for this element.
   */
  createRenderRoot() {
    return this;
  }

  render() {
    if (!config.showMaintenanceMessage || this._wasSeen) {
      return null;
    }

    return html`
      <osk-modal trigger-id="maintenance-modal" @close=${this.handleCloseModal}>
        <h2 slot="modal-header">Prebieha plánovaná údržba Zákazníckej&nbsp;zóny.</h2>
        <div slot="modal-body">
          <div class="grid">
            <div class="grid__col--lg-8 align-self-middle">
              <p class="mb-none">
                Neustále vylepšujeme našu ponuku i&nbsp;služby. Občas preto musíme na chvíľu
                prevádzku Zákazníckej zóny obmedziť. Ďakujeme za pochopenie, o&nbsp;chvíľu ju opäť
                spustíme v&nbsp;štandardnom režime.
              </p>
            </div>
            <div class="grid__col--lg-4">
              <img
                class="img"
                src="assets/images/working-man-with-error-screen.svg"
                alt="Muž pracujúci pred obrazovkou s chybou"
                role="presentation"
              />
            </div>
          </div>
        </div>
        <div slot="modal-footer">
          <div class="buttons">
            <button class="btn" @click=${this.handleCloseModal}>Rozumiem</button>
          </div>
        </div>
      </osk-modal>
    `;
  }
}

export default MaintenanceMessage;
